module.exports = __webpack_public_path__ + "static/espuma-1ae8ddca9184939f63a680778aa00f2f.jpg";